import { render, staticRenderFns } from "./TermsForChain.vue?vue&type=template&id=6c31e746&scoped=true"
import script from "./TermsForChain.vue?vue&type=script&lang=js"
export * from "./TermsForChain.vue?vue&type=script&lang=js"
import style0 from "./TermsForChain.vue?vue&type=style&index=0&id=6c31e746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31e746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VProgressCircular})
